var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [true ? _c('Header', {
    attrs: {
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.headerSection,
      "meta": _vm.meta
    }
  }) : _vm._e(), _vm.getModuleConfigForPage('form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfigForPage("form_title")) + " ")]) : _vm._e(), _vm.getModuleConfigForPage('form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfigForPage("form_desc")) + " ")]) : _vm._e(), _c('div', {
    staticClass: "s-tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('button', {
      key: tab.order,
      staticClass: "s-tab",
      on: {
        "click": function click($event) {
          return _vm.handleClickTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.title) + " ")]);
  }), 0), _c('router-view'), _c('MaacModal', {
    ref: "maacModal",
    attrs: {
      "qr-code-text": _vm.maacModalData.qrCodeText,
      "is-loading-qr-code": _vm.maacModalData.isLoadingQrCode,
      "redirect-url": _vm.maacModalData.redirectUrl
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }